export default __webpack_public_path__ + "static/media/categoria_facture.90a51be0.svg";